export default __webpack_public_path__ + "static/media/bg.3c7b91a4.jpg";